import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import { logger } from "../../helpers/logger";
import { initiateAXIOS } from "../../config/axios";
import { useDebounce } from "../hooks";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const SearchSelectDropdown = ({
  sx = {},
  selectItem,
  selectedItem,
  error = null,
  setError = null,
  disabled = false,
  urlLimit,
  label = null,
  placeholder,
}) => {
  const { t } = useTranslation("cms");

  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputSearch, setInputSearch] = useState("");

  /**
   * 1 Second delay after input value change to do API fetch
   */
  const debouncedSearchTerm = useDebounce(inputSearch, 1000);

  const getData = async (search) => {
    const access_token = sessionStorage.getItem("access_token");
    setLoading(true);
    try {
      let query = search ? "&nameLike=" + search : "";
      const { data } = await initiateAXIOS.get(urlLimit + query, {
        headers: { authorization: `Bearer ${access_token}` },
      });

      setOptions(data.items || []);
    } catch (error) {
      logger.error(error);

    } finally {
      setLoading(false);
    }
  };

  useEffect(
    () => {
      if (debouncedSearchTerm) {
        getData(debouncedSearchTerm);
      } else if (debouncedSearchTerm === "" && open) {
        getData();
      } else {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm, open] // Only call effect if debounced search term changes
  );

  return (
    <Box sx={sx}>
      <Autocomplete
        fullWidth
        size="small"
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        options={options}
        getOptionLabel={(option) => option.name || ""}
        loading={loading}
        value={selectedItem}
        disabled={disabled}
        onInputChange={(_, value) => {
          setInputSearch(value);
        }}
        onChange={(_, newValue) => {
          selectItem(newValue);
          if (setError) setError(false);
        }}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField
            label={label}
            {...params}
            error={error}
            helperText={error ? t("contentSelector.requiredText") : ""}
            placeholder={placeholder}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default SearchSelectDropdown;
